import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "primereact/tooltip";
import { TabView, TabPanel } from 'primereact/tabview';
import { Checkbox } from "primereact/checkbox";
import { FileUpload } from "primereact/fileupload";
import _ from "lodash";

import "../index.css"

import { Button, CalendarField, DropDownField, TextInputField, AutoCompleteField } from "../../../helpers"


import Loading from "../../../common/Loading"
import CopyToClipboard from "../../../common/CopyToClipboard";
import FileViewAndRemove from "../../../common/FileViewAndRemove";
import PMUserName from "../../../common/PMUserName";

import Scheduling from "./Scheduling";
import SubmitPOQuantity from "./SubmitPOQuantity";

import { getUsers } from "../../../services/api/user";
import { getPODocDetailsUsingPOParser, insertPOPunch } from "../../../services/api/buyerPO";
import { getBuyerPOByBuyerPOId } from "../../../services/api/buyerPO";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../../services/api/buyerReqItem";
import { searchUserRoles } from '../../../services/api/user';
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { getDateString, getManagerIds, validateInputs, sortArrayOfObjectsInAlphabeticalOrder, checkPermissions, getUploadedFileObj, getReqShortDetails, getFullName, getCompanyShortName } from "../../../utils";

import { buyerPOSchema} from "../../../validation/buyerPO"
import { getIncrementalReqLogByBuyerReqId } from "../../../services/api/incrementalReqLogs";


const POPunch = (props) => {
    const { buyerPOId, selectedReq } = props

    const [isLoading, setIsLoading] = useState(false)
    const [showSubmitPO, setShowSubmitPO] = useState(false)
    const [isPunchDisable, setIsPunchDisable] = useState(false)

    const [buyerPOErrors, setBuyerPOErrors] = useState({})

    const [buyerPO, setBuyerPO] = useState({})
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [poSchedule, setPOSchedule] = useState([])
    const [poScheduleItems, setPOScheduleItems] = useState([])
    const [poPunch, setPOPunch] = useState([])
    const [poPunchItems, setPOPunchItems] = useState([])
    const [dispatchNoteItems, setDispatchNoteItems] = useState([])
    const [materialData, setMaterialData] = useState([])
    const [poPunchFile, setPOPunchFile] = useState({})
    const [revisedPOPunchFile, setRevisedPOPunchFile] = useState({})
    const [poParserResult, setPOParserResult] = useState({po_date: "", po_number: "", po_total_amount: ""})
    const [incrementalReqLogs, setIncrementalReqLogs] = useState([])

    const [poPunchCreatedUsers, setPOPunchCreatedUsers] = useState([])
    const [poScheduleCreatedUsers, setPOScheduleCreatedUsers] = useState([])
    const [buyerCompanyUsers, setBuyerCompanyUsers] = useState([])
    const [searchedBuyerCompanyUsers, setSearchedBuyerCompanyUsers] = useState([])
    const [recipientUser, setRecipientUser] = useState(null)
    const [showRecipientUserInput, setShowRecipientUserInput] = useState(false)

    const usersData = useSelector(state => state.userDetails)
    const orderTypes = useSelector(state => state.common.orderTypes)

    const pmCompanyUsers = usersData?.PMCompanyDetails?.companyUsers ? usersData?.PMCompanyDetails?.companyUsers : []

    const dispatch = useDispatch()

    useEffect(()=>{
        if (buyerPOId){
            getBuyerPO()
        }
    }, [buyerPOId])

    const getBuyerPO = async () => {
        setIsLoading(true)

        let response
        if (buyerPOId){
            response = await getBuyerPOByBuyerPOId(buyerPOId)
        }

        if (response?.failure){
            dispatch(raiseToast({severity:'error', summary: response.data.error, detail:'Buyer POs not fetched', life: 3000}))
        } else {
            let buyerPOItems = response?.data.buyerPOItems
            let updatedPOPunch = response?.data.poPunch
            let updatedPOScheduleItems = response?.data.poScheduleItem
            let updatedPOPunchItems = response?.data.poPunchItem
            let updatedPOSchedule = response?.data.poSchedule
            const dispatchNoteItems = response?.data.dispatchNoteItem
            let equalQuantityScheduled = true
            buyerPOItems?.map(eachBuyerPOItem => {
                let totalScheduledQty = 0
                updatedPOScheduleItems?.map(eachPOScheduleItem => {
                    if (eachPOScheduleItem.buyerReqItemId === eachBuyerPOItem.buyerReqItemId && eachPOScheduleItem?.statusId === 1) {
                        totalScheduledQty += eachPOScheduleItem.scheduledQty
                    }
                })
                if (totalScheduledQty !== eachBuyerPOItem?.bPOQty) {
                    equalQuantityScheduled = false
                }
            })
            let equalQuantityPunched = true
            buyerPOItems?.map(eachBuyerPOItem => {
                let totalPunchedQty = 0
                updatedPOPunchItems?.map(eachPOPunchItem => {
                    if (eachPOPunchItem.buyerReqItemId === eachBuyerPOItem.buyerReqItemId) {
                        totalPunchedQty += eachPOPunchItem.punchQty
                    }
                })
                if (totalPunchedQty !== eachBuyerPOItem?.bPOQty) {
                    equalQuantityPunched = false
                }
            })
            let updatedBuyerPO
            if (response?.data.buyerPO?.poSource === "Normal") {
                updatedBuyerPO = { ...response?.data.buyerPO, isPunchDone: true, isNormalPunchDone: true }
                if (!updatedBuyerPO.poDocDate || !updatedBuyerPO.poReceivedDate || !updatedBuyerPO.clientPONum){
                    updatedBuyerPO = {...updatedBuyerPO, isPartiallyUpdated: true}
                }
            } else if (response?.data.buyerPO?.poSource === "Via Mail") {
                updatedBuyerPO = { ...response?.data.buyerPO, clientPONum : "", isNormalPunchDone: false, isPunchDone: true }
            } else if (response?.data.buyerPO?.poSource === null) {
                updatedBuyerPO = { ...response?.data.buyerPO, isPunchDone: false, clientPONum : "" , poSource: "", poReceivedDate: ""}
            }
            
            if (!updatedBuyerPO.isPartiallyUpdated && (!updatedBuyerPO.poRevisedDate && !updatedBuyerPO.revisedDocProof)){
                updatedBuyerPO = {...updatedBuyerPO, isRevisedDetailsEntered: false }
            } else if (updatedBuyerPO.poRevisedDate && updatedBuyerPO.revisedDocProof){
                updatedBuyerPO = {...updatedBuyerPO, isRevisedDetailsEntered: true }
            }

            if (updatedBuyerPO?.isRecurringPO === null){
                updatedBuyerPO = {...updatedBuyerPO, isRecurringPO : false}
            }

            const incrementalReqLogRes = await getIncrementalReqLogByBuyerReqId(updatedBuyerPO.buyerReqId)
            if (incrementalReqLogRes.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Incremental Req Punch', detail: incrementalReqLogRes.data.error, life: 3000}))
            }

            if (incrementalReqLogRes.data.length){ //  && !updatedBuyerPO.clientPONum add this and check for via mail
                updatedBuyerPO = {...updatedBuyerPO, clientPONum: incrementalReqLogRes.data[0].clientPONum}
            }
            
            let buyerReqItemIds = []
            buyerPOItems?.map(eachBuyerPOItem => buyerReqItemIds.push(eachBuyerPOItem?.buyerReqItemId))
            let data = { buyerReqItemsIds : buyerReqItemIds }
            let materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds(data)

            if(materialDetailsRes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Material Details', detail: materialDetailsRes?.data.error, life: 3000}))
            }

            const updatedBuyerPOItems = buyerPOItems?.map(eachBuyerPOItem => ({...eachBuyerPOItem, columnViseValues: {}}))

            const poPunchAndScheduleCreatedUserIds = []
            updatedPOPunch?.map(eachPOPunch => poPunchAndScheduleCreatedUserIds.push(eachPOPunch?.createdBy))
            updatedPOSchedule?.map(eachPOSchedule => poPunchAndScheduleCreatedUserIds.push(eachPOSchedule?.createdBy))

            const usersRes = await getUsers({userIds: poPunchAndScheduleCreatedUserIds, paginator: false})
            if(usersRes?.failure){
                dispatch(raiseToast({severity:'error', summary: 'User Response', detail: usersRes?.data.error, life: 3000}))
            }

            let poPunchCreatedUsers = []
            let poScheduleCreatedUsers = []
            updatedPOPunch.map(eachPOPunch => {
                let eachUser = usersRes?.data?.data?.find(eachUser => eachUser?.userId === eachPOPunch?.createdBy)
                if (eachUser?.userId){
                    poPunchCreatedUsers.push(eachUser)
                }
            })
            updatedPOSchedule.map(eachPOSchedule => {
                let eachUser = usersRes?.data?.data?.find(eachUser => eachUser?.userId === eachPOSchedule?.createdBy)
                if (eachUser?.userId){
                    poScheduleCreatedUsers.push(eachUser)
                }
            })

            setPOPunchCreatedUsers(poPunchCreatedUsers)
            setPOScheduleCreatedUsers(poScheduleCreatedUsers)
            setMaterialData(materialDetailsRes?.data)
            setBuyerPO(updatedBuyerPO)
            setPOPunch(updatedPOPunch)
            setPOPunchItems(updatedPOPunchItems)
            setBuyerPOItems(updatedBuyerPOItems)
            setPOSchedule(updatedPOSchedule)
            setPOScheduleItems(updatedPOScheduleItems)
            setShowSubmitPO(equalQuantityScheduled)
            setIsPunchDisable(equalQuantityPunched)
            setDispatchNoteItems(dispatchNoteItems)
            
            setIncrementalReqLogs(incrementalReqLogRes.data)


            const  buyerCompanyUserSearchParams = { 
                companyIds: [updatedBuyerPO.companyId], 
                statusId: 1, 
                include: [{ model: "user", attributes: ["firstName", "lastName", "emailId", "phoneNumber"] }], 
                paginator: false
            }
            
            await getBuyerCompanyUsersData(buyerCompanyUserSearchParams)
        }
        setIsLoading(false)
    }

    const getBuyerCompanyUsersData = async (searchParams) => {
        setIsLoading(true)
        const buyerCompanyUsersDataResponse = await searchUserRoles({...searchParams})
        // console.log("buyerCompanyUsersData-response", buyerCompanyUsersDataResponse)
        setIsLoading(false)
        if(buyerCompanyUsersDataResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: buyerCompanyUsersDataResponse.data.error, life: 3000}))
        }
        else{
            let usersList = buyerCompanyUsersDataResponse.data.data.map(eachUser => {
                return {
                    userId: eachUser.userId,
                    fullName: eachUser["user.firstName"] + " " + (eachUser?.["user.lastName"] ? eachUser["user.lastName"] : ''),
                    phoneNumber: eachUser["user.phoneNumber"]
                }
            })

            usersList = _.uniqBy(usersList, 'userId');
            usersList = sortArrayOfObjectsInAlphabeticalOrder(usersList, 'fullName')
            setBuyerCompanyUsers(usersList)
        }
    }
        
    const poTypeData = [
        { label: "Normal", value: "Normal" },
        { label: "Via Mail", value: "Via Mail" }
    ]

    const fileUploadHandler = async ({ files, options }, doc_name) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: doc_name })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        if (doc_name === "REVISED_PO_DOC") {
            setRevisedPOPunchFile(fileArr[0])
        } else {
            setPOPunchFile(fileArr[0])
            parsePODoc(fileArr[0].fileName, fileArr[0].dataURI)
        }
    }

    const handlePunchInputChange = (e) => {
        if (e.target.name === "poSource"){
            if (e.target.value === "Via Mail"){
                setBuyerPO(prevState => ({...prevState, [e.target.name] : e.target.value, "poDocDate": null, "clientPONum": ""}))
            }
            setBuyerPO(prevState => ({...prevState, [e.target.name] : e.target.value}))
        }else if (e.target.name === "clientPONum"){
            setBuyerPO(prevState => ({...prevState, [e.target.name] : e.target.value}))
        }else{
            setBuyerPO(prevState => ({...prevState, [e.target.name] : e.target.value}))
        }
    }

    const handlePunchClick = async (buyerPO, buyerPOItems) => {
        const validationsErrs = await validateInputs(buyerPOSchema, buyerPO)
        console.log("validationsErrs", validationsErrs, buyerPOSchema, buyerPO)
        if (validationsErrs?.error) {
            setBuyerPOErrors({ ...validationsErrs.error })
        } else {
            if (buyerPO.poRevisedDate){
                if (!(Object.values(revisedPOPunchFile)?.length > 0 || buyerPO.revisedDocProof)){
                    return dispatch(raiseToast({ severity: 'error', detail: 'Please Upload the Revise PO document.' }))
                }
            }
            if (Object.values(revisedPOPunchFile)?.length > 0 || buyerPO.revisedDocProof){
                if (!buyerPO.poRevisedDate){
                    return dispatch(raiseToast({ severity: 'error', detail: 'Please Select PO Clarified Date'}))
                }
            }
            if (buyerPO.poSource === "Normal" && incrementalReqLogs.length && buyerPO.clientPONum.trim() !== incrementalReqLogs[0].clientPONum){
                return dispatch(raiseToast({ severity: 'error', detail: `Client PO Num should be same as ${incrementalReqLogs[0].clientPONum} this is a incremental Requirement`}))
            }

            if (buyerPO?.poSource === "Normal" && (!(buyerPO?.docProof?.length > 0) && !(Object.values(poPunchFile)?.length > 0))) {
                dispatch(raiseToast({ severity: 'error', detail: 'Please Upload the PO document.', life: 3000 }))
            }
            else if (window.confirm("Do You want to continue?")) {
                setIsLoading(true)

                if (Object.values(poPunchFile)?.length > 0) {
                    buyerPO.uploadFile = poPunchFile
                }

                let response
                const activeRoleId = usersData?.activeRoleId
                const relatedUserCompany = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
                if (buyerPO?.isRecurringPO) {
                    const updatedBuyerPOItems = buyerPOItems?.map(eachBuyerPOItem => (
                        {
                            ...eachBuyerPOItem,
                            pmCompanyId: relatedUserCompany?.pmCompanyId,
                            pmBranchId: buyerPO?.pmBranchId,
                            statusId: 3,
                            createdBy: usersData?.userId,
                            updatedBy: usersData?.userId
                        }
                    ))
                    let data = {
                        buyerPOId: buyerPOId,
                        buyerPO: {
                            clientPONum: buyerPO.poSource === "Normal" ? buyerPO.clientPONum.trim() : `Via Mail : ${buyerPO.docNo}`,
                            isRecurringPO: buyerPO.isRecurringPO,
                            poDocDate: buyerPO.poDocDate,
                            buyerPOId: buyerPO.buyerPOId,
                            poReceivedDate: buyerPO.poReceivedDate,
                            docNo: buyerPO.docNo,
                            poSource: buyerPO.poSource,
                            pmCompanyId: relatedUserCompany?.pmCompanyId,
                            pmBranchId: buyerPO?.pmBranchId,
                            companyId: buyerPO.companyId,
                            createdBy: usersData?.userId,
                            updatedBy: usersData?.userId,
                            docProof: buyerPO?.docProof,
                            uploadFile: poPunchFile,
                            revisedPOFile: revisedPOPunchFile,
                            poRevisedDate: buyerPO.poRevisedDate,
                            statusId: 3,
                            recipientUserId: recipientUser ? recipientUser?.userId : null
                        },
                        buyerPOItems: updatedBuyerPOItems
                    }
                    response = await insertPOPunch(data)
                } else {
                    const relatedBuyerPOItems = buyerPOItems.map(eachBuyerPOItem => {
                        let expectedDeliveryDate = new Date(buyerPO?.poReceivedDate)
                        let expectedDelivery = expectedDeliveryDate.getDate() + parseInt(eachBuyerPOItem?.leadTime)
                        expectedDeliveryDate.setDate(expectedDelivery)
                        return {
                            buyerPOId: eachBuyerPOItem?.buyerPOId,
                            buyerPOItemId: eachBuyerPOItem?.buyerPOItemId,
                            buyerReqId: eachBuyerPOItem?.buyerReqId,
                            buyerReqItemId: eachBuyerPOItem?.buyerReqItemId,
                            materialId: eachBuyerPOItem?.materialId,
                            fileNo: eachBuyerPOItem?.fileNo,
                            docNo: eachBuyerPOItem?.docNo,
                            pmCompanyId: relatedUserCompany?.pmCompanyId,
                            pmBranchId: buyerPO?.pmBranchId,
                            companyId: buyerPO.companyId,
                            leadTime: eachBuyerPOItem?.leadTime,
                            punchQty: eachBuyerPOItem?.bPOQty,
                            bPOQty: eachBuyerPOItem?.bPOQty,
                            expectedDeliveryDate: expectedDeliveryDate,
                            createdBy: usersData?.userId,
                            updatedBy: usersData?.userId,
                            recipientUserId: recipientUser ? recipientUser?.userId : null
                        }
                    })
                    let data = {
                        buyerPOId: buyerPOId,
                        poPunch: poPunch,
                        poSchedule: poSchedule,
                        buyerPO: {
                            buyerPOId: buyerPO?.buyerPOId,
                            buyerReqId: buyerPO?.buyerReqId,
                            fileNo: buyerPO?.fileNo,
                            docNo: buyerPO?.docNo,
                            clientPONum: buyerPO.poSource === "Normal" ? buyerPO.clientPONum.trim() : `Via Mail : ${buyerPO.docNo}`,
                            isRecurringPO: buyerPO.isRecurringPO,
                            isPunchDone: buyerPO?.isPunchDone,
                            poDocDate: buyerPO.poDocDate,
                            poReceivedDate: buyerPO.poReceivedDate,
                            poSource: buyerPO.poSource,
                            bPOQty: buyerPO?.bPOQty,
                            shipAddrId: buyerPO?.shipAddrId,
                            pmBillAddrId: buyerPO?.pmBillAddrId,
                            docProof: buyerPO?.docProof,
                            uploadFile: poPunchFile,
                            revisedPOFile: revisedPOPunchFile,
                            poRevisedDate: buyerPO.poRevisedDate,
                            pmCompanyId: relatedUserCompany?.pmCompanyId,
                            pmBranchId: buyerPO?.pmBranchId,
                            companyId: buyerPO.companyId,
                            createdBy: usersData?.userId,
                            updatedBy: usersData?.userId,
                            recipientUserId: recipientUser ? recipientUser?.userId : null
                        },
                        buyerPOItems: relatedBuyerPOItems
                    }
                    response = await insertPOPunch(data)
                }
                
                if (response.failure) {
                    if (response.status === 409) {
                        const { errorDetails } = response.data
                        dispatch(raiseToast({
                            severity: 'error',
                            detail: (
                                <span>
                                    The purchase order (PO) punch can't be processed as materials already exist with BuyerPO No:&nbsp;
                                    <strong style={{ color: '#00baaa' }}>
                                        {errorDetails.buyerPODocNo}
                                    </strong>
                                    <CopyToClipboard text={errorDetails.buyerPODocNo} />.
                                    To continue, please cancel the previous buyer PO.
                                </span>
                            ),
                            life: 6000
                        }))
                    }else{
                        dispatch(raiseToast({ severity: 'error', summary: 'PO Punch', detail: response?.data?.error, life: 3000 }))
                    }
                } else {
                    dispatch(raiseToast({ severity: 'success', detail: "PO Punch is Done", life: 3000 }))
                    getBuyerPO()
                    setPOPunchFile({})
                }
                setIsLoading(false)
                setBuyerPOErrors({})
            }
        }
    }

    const handleRecurringClick = (e) => {
        setBuyerPO(prevState => ({...prevState, [e.target.name] : e.checked}))
    }

    const removeFile = (docName) => {
        if (docName === "REVISED_PO_DOC"){
            setRevisedPOPunchFile({})
        }else{
            setPOPunchFile({})
            setBuyerPO(prevState => ({ ...prevState, docProof : null }))
        }
    }


    const handleUpdatedPOPunch = (data) => {
        const updatedPOPunch = poPunch.map(eachPOPunch => {
            if(eachPOPunch.poPunchId === data.updatedPOPunch.poPunchId){
                return {...data.updatedPOPunch}
            }
            return eachPOPunch
        })

        const updatedPOPunchItems = poPunchItems.map(eachPOPunchItem => {
            const relatedPOPunchItem = data.updatedPOPunchItems.find(eachItem => eachItem.poPunchItemId === eachPOPunchItem.poPunchItemId)

            if(relatedPOPunchItem){
                return {...relatedPOPunchItem}
            }
            return eachPOPunchItem
        })

        setIsPunchDisable(false)
        setPOPunch(updatedPOPunch)
        setPOPunchItems(updatedPOPunchItems)
    }

    const searchBuyerCompanyUsers = (event) => {
        const relatedBuyerCompanyUsers = buyerCompanyUsers.filter(eachUser => eachUser.fullName.toLowerCase().startsWith(event.query.trim().toLowerCase()))
        if(relatedBuyerCompanyUsers.length > 0){
            setSearchedBuyerCompanyUsers(relatedBuyerCompanyUsers)
        }else{
            setSearchedBuyerCompanyUsers(["This is empty"])
        }
    }

    const handleRecipientUserChange = (event) => {
        setRecipientUser(event.target.value)
    }

    const parsePODoc = async (fileName, dataURI) => {
        setIsLoading(true)
    
        let data = {
            "buyerPOId": buyerPO.buyerPOId,
            "documentName": "BUYERPO",
            "fileName": fileName,
            "dataURI": dataURI
        }
        const poParserRes = await getPODocDetailsUsingPOParser(data)
        console.log("poParserRes", poParserRes)

        if (poParserRes.failure) {
            dispatch(raiseToast({ severity: 'error', detail: poParserRes?.data?.error, life: 3000 }))
        } else {
            //dispatch(raiseToast({ severity: 'success', detail: "", life: 3000 }))

            const response = poParserRes.data
            if(response.status === 400){
                setPOParserResult({
                    po_date: "", 
                    po_number: "", 
                    po_total_amount: ""
                })
            } else {
                setPOParserResult({
                    po_date: response.data?.po_date ? response.data?.po_date : "", 
                    po_number: response.data?.po_date ? response.data?.po_date : "", 
                    po_total_amount: response.data?.po_date ? response.data?.po_date : ""
                })

                let poUpdateObj = {}
                if(response.data?.po_date && !buyerPO.poDocDate){
                    const offsetInMilliseconds = 5.5 * 60 * 60 * 1000
                    let poDate = new Date(response.data.po_date)
                    poDate = poDate.setTime(poDate.getTime() + offsetInMilliseconds);
                    poUpdateObj.poDocDate = poDate
                }
                if(response.data?.po_number && !buyerPO.clientPONum){
                    poUpdateObj.clientPONum = response.data.po_number
                }

                console.log("poUpdateObj", poUpdateObj)

                setBuyerPO(prevState => ({...prevState, ...poUpdateObj}))

                if(response.message){
                    dispatch(raiseToast({ severity: 'error', detail: response.message, life: 5000 }))
                }
            }
        }
        setIsLoading(false)
    }
    
    let minPOReceivedDate = null
    if (buyerPO?.poDocDate){
        minPOReceivedDate = new Date(buyerPO?.poDocDate)
    }

    let maxPODocDate = new Date()
    if (buyerPO?.poReceivedDate){
        maxPODocDate = new Date(buyerPO?.poReceivedDate)
    }

    const createdAtString = buyerPO?.createdAt ? getDateString(buyerPO?.createdAt) : ""
    let buyerName = ""
    let companyName = ""
    if (selectedReq){
        if(selectedReq["buyer.firstName"]){
            buyerName = selectedReq["buyer.firstName"]
        }
        if(selectedReq["buyer.lastName"]){
            buyerName += " " + selectedReq["buyer.lastName"]
        }
        companyName = `${selectedReq["company.companyName"]} - ${selectedReq["buyerCompanyBranch.branchName"]}`
    }

    let canEditable = false
    if (buyerPO?.createdBy === usersData?.userId){
        canEditable = true
    }else {
        let managerIds = getManagerIds(usersData?.userId, buyerPO?.pmBranchId, pmCompanyUsers)
        if (managerIds.includes(usersData?.userId)){
            canEditable = true
        }
    }

    let isUploadRevisedPoPermitted = false
    const permissionDetails = checkPermissions({ ...usersData, permissions: [185] })
    if(permissionDetails.isPermitted){
        isUploadRevisedPoPermitted = permissionDetails.isPermitted
    }

    const renderRequirementDetails = (buyerReq) => {
        const { shortDenotation, fullDenotation } = getReqShortDetails(buyerReq, orderTypes)
        const kamName = getFullName(buyerReq["kam.firstName"], buyerReq["kam.lastName"])
        const companyDisplayName = getCompanyShortName(buyerReq["company.companyName"])
        const reqCreatedAt = getDateString(buyerReq.createdAt)

        return (
            <p className="m-0">
                <span style={{fontWeight:"bold"}}>Req No: </span><span className="ml-1">{buyerReq["docNo"]} <CopyToClipboard text={buyerReq["docNo"]} /></span>
                <span className={`requirement-short-details`}> {shortDenotation}</span>
                <span className=""> by <PMUserName userName={kamName} userId={buyerReq.createdBy} /> ({buyerReq["pmCompanyBranch.branchName"]})</span> 
                <span className=""> on {reqCreatedAt}</span>
                <span className=""> for </span> <span style={{fontWeight:"bold"}}>{companyDisplayName} </span> <span className="ml-1"> - {buyerReq["buyerCompanyBranch.branchName"]} - {buyerName}</span>  

                <Tooltip target={`.requirement-short-details`} position='bottom'>
                    <span>{fullDenotation}</span>
                </Tooltip>
            </p>
        )
    }   
    
    let isReuploadBPoDocPermitted = false
    const bPODocUploadPermissionDetails = checkPermissions({ ...usersData, permissions: [260] })
    if(bPODocUploadPermissionDetails.isPermitted){
        isReuploadBPoDocPermitted = bPODocUploadPermissionDetails.isPermitted
    }

    return (
        <div className="po-punch-modal">
            <Loading visible={isLoading}/>
            { selectedReq ? 
                <p className="m-0">
                    {renderRequirementDetails(selectedReq)}
                </p> 
                : "" 
            }
            {
                !buyerPOId && selectedReq && 
                    <div className="flex justify-content-center mt-2">
                        <p className="font-bold text-sm">Please Select the Buyer PO Doc Number.</p>
                    </div>
            }
            {
                buyerPOId &&
                <TabView className="mt-1">
                    <TabPanel header="PO Details">
                        <div className={`p-card mt-2 ${buyerPO?.statusId === 6 ? 'cancelled-watermark' : ''} ${buyerPO?.statusId === 4 ? 'force-closed-watermark' : ''} `}>
                            <div className="grid">
                                <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                    <DropDownField name="poSource" optionLabel="label" optionValue="value" options={poTypeData} errorMessage={buyerPOErrors?.poSource} labelText="PO Type" disabled={buyerPO?.isNormalPunchDone && buyerPO?.poSource} value={buyerPO?.poSource} required onChange={e => handlePunchInputChange(e)}/>
                                </div>
                                <div className="flex flex-column col-12 mb-2 md:col-10 lg:col-10 lg:mb-0 mt-0 pt-0 pr-0">
                                    <div className="grid mt-0">
                                        {
                                            buyerPO?.docProof || poPunchFile.url ? (
                                            <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0" >
                                                <label className="text-xs mb-2">PO Document: </label>
                                                <div className="grid flex p-0">
                                                    {
                                                        isReuploadBPoDocPermitted ?
                                                            <div className="col-12 md:col-4 lg:col-9 lg:mb-0 pr-0">
                                                                <FileUpload className="upload-btn" mode="basic" name="docProof" accept=".jpg,.jpeg,.png,.pdf,.html"  customUpload auto chooseLabel="Upload File" uploadHandler={files => fileUploadHandler(files, "BUYER_PO")}  />
                                                            </div>
                                                            : null
                                                    }
                                                    <div className="col-12 md:col-4 lg:col-3 lg:mb-0" style={{...(isReuploadBPoDocPermitted && { paddingLeft: "0px" })}}>
                                                        <FileViewAndRemove doc={poPunchFile.url ? poPunchFile : {url: buyerPO?.docProof}} />
                                                    </div>
                                                    {/* {
                                                        buyerPO?.docProof && (buyerPO?.isNormalPunchDone && !buyerPO?.isPartiallyUpdated) ? '' : 
                                                            (
                                                                <>
                                                                    <span onClick={() => removeFile()} className="cursor-pointer text-sm text-red-600 ml-2">
                                                                        Remove
                                                                    </span>
                                                                </>
                                                            )
                                                    } */}
                                                </div>
                                            </div>
                                            ) : (
                                                buyerPO?.poSource === "Normal" &&
                                                <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                                    <label htmlFor="poDoc" className="text-xs mb-1">PO Document: </label>
                                                    <FileUpload className="upload-btn" mode="basic" name="docProof" accept=".jpg,.jpeg,.png,.pdf,.html"  customUpload auto chooseLabel="Upload PO File" uploadHandler={files => fileUploadHandler(files, "BUYER_PO")}  />
                                                </div>
                                            )
                                        }
                                        {
                                            buyerPO?.poSource === "Normal" && 
                                            <>
                                                <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                                    <TextInputField name="clientPONum" labelText="PO Number" placeholder="" errorMessage={buyerPOErrors?.clientPONum} disabled={(buyerPO?.isNormalPunchDone && buyerPO?.clientPONum || (!poPunchFile.url && !buyerPO?.docProof)) || incrementalReqLogs.length} value={(buyerPO?.isPunchDone || !isPunchDisable) ? buyerPO?.clientPONum : ""} required onChange={e => handlePunchInputChange(e)}/>
                                                </div>
                                                <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                                    <CalendarField name="poDocDate" labelText="PO Document Date" placeholder="" maxDate={new Date()} errorMessage={buyerPOErrors?.poDocDate} disabled={buyerPO?.isNormalPunchDone && buyerPO?.poDocDate && !buyerPO?.isPartiallyUpdated || (!poPunchFile.url && !buyerPO?.docProof)} value={buyerPO?.poDocDate ? new Date(buyerPO?.poDocDate) : null} required onChange={e => handlePunchInputChange(e)}/>
                                                </div>
                                            </>
                                        }
                                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:mb-0">
                                            <CalendarField name="poReceivedDate" labelText="PO Received Date" disabled={buyerPO?.isPunchDone && buyerPO?.poReceivedDate} minDate={new Date(minPOReceivedDate)} maxDate={new Date()} errorMessage={buyerPOErrors?.poReceivedDate} placeholder="" value={buyerPO?.poReceivedDate ? new Date(buyerPO?.poReceivedDate) : null} showTime hourFormat="12" showIcon required onChange={e => handlePunchInputChange(e)}/>
                                        </div>
                                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:mb-0">
                                            <TextInputField name="priceBeforeTax" labelText="Amount before tax" disabled placeholder="" value={buyerPO?.bPOTotalAmountBeforeTax} onChange={e => handlePunchInputChange(e)}/>
                                        </div>
                                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:mb-0">
                                            <TextInputField name="priceAfterTax" labelText="Total Amount" disabled placeholder="" value={buyerPO?.bPOTotalAmountWithTax} onChange={e => handlePunchInputChange(e)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-row justify-content-between">
                                <div className="flex flex-row col-12 lg:col-4 pl-0">
                                    <Checkbox inputId="recurring_po" name="isRecurringPO" value="Recurring Purchase Order" disabled={(buyerPO?.isNormalPunchDone && !buyerPO?.isPartiallyUpdated) || buyerPO?.statusId === 6}  checked={buyerPO?.isRecurringPO} onChange={e => handleRecurringClick(e)}/> {/*disabled={buyerPO?.isPunchDone} */}
                                    <label htmlFor="recurring_po" className="ml-2">Recurring Purchase Order</label>
                                </div>
                            </div>
                            <div className="flex flex-row">
                                {
                                    showRecipientUserInput ? 
                                        <>
                                            <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                                <label htmlFor="recipientUserId" style={{fontSize:"12px", marginBottom:"3px"}}>
                                                    Recipient User
                                                    <Tooltip target=".custom-target-icon" position="right" content="If user not found plase add the user in company and refresh the page" />
                                                    <i className="pi pi-info-circle custom-target-icon ml-2"></i>
                                                </label>
                                                <AutoCompleteField name="recipientUserId" suggestions={searchedBuyerCompanyUsers} field="fullName" value={recipientUser} onChange={e => handleRecipientUserChange(e)} searchMethod={searchBuyerCompanyUsers} dropdown forceSelection />
                                            </div>
                                            <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                                <TextInputField name="recipientUserPhoneNo" labelText="Recipient User Phone No" placeholder="" value={recipientUser?.phoneNumber} onChange={e => handlePunchInputChange(e)} disabled />
                                            </div>
                                        </>
                                        :
                                        <div className="mt-3 mb-2">
                                            <span onClick={() => setShowRecipientUserInput(true)}style={{cursor:"pointer"}}><i className='pi pi-plus-circle mr-2' style={{color:'#00baaa'}} />Add Recipient User</span>
                                        </div>                                             
                                }
                                {
                                    false && buyerPO &&
                                    <>
                                        <div className="flex flex-column col-12 mb-2 ml-5 md:col-2 lg:mb-0">
                                            <CalendarField name="poRevisedDate" labelText="PO Clarified Date" disabled={buyerPO.isRevisedDetailsEntered} minDate={new Date()} value={buyerPO.poRevisedDate ? new Date(buyerPO.poRevisedDate) : null} onChange={e => handlePunchInputChange(e)}/>
                                        </div>
                                        {
                                            buyerPO.revisedDocProof || revisedPOPunchFile.url ? (
                                            <div className="flex flex-column col-12 mb-2 md:col-4 lg:col-4 lg:mb-0" >
                                                <div className='flex col-12 mt-0 pt-0 '>
                                                    <div className='flex flex-row'>
                                                        <div className="flex flex-column justify-content-center mt-0">
                                                            <label htmlFor="poDoc" className="text-xs mb-1">Revised Document: </label>
                                                            <div className="flex">
                                                                <FileViewAndRemove doc={buyerPO.revisedDocProof ? {url: buyerPO.revisedDocProof} : revisedPOPunchFile } handleRemoveDoc={removeFile} />
                                                                {
                                                                    buyerPO.revisedDocProof && buyerPO.isRevisedDetailsEntered ? '' : 
                                                                        <div className="">
                                                                            {/* <Button className="decrement-btn-icon p-0" icon="pi pi-minus-circle" text onClick={(e) => removeFile(e, "REVISED_PO_DOC")} size="small" /> */}
                                                                            <span onClick={() => removeFile("REVISED_PO_DOC")} className="cursor-pointer text-sm text-red-600 ml-2">
                                                                                Remove
                                                                            </span>
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            ) : (
                                                buyerPO &&
                                                <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                                    <label htmlFor="poDoc" className="text-xs mb-1">Revised Document: </label>
                                                    <FileUpload className="upload-btn" mode="basic" name="revisedDocProof" accept=".jpg,.jpeg,.png,.pdf,.html"  customUpload auto chooseLabel="Upload Revised PO" uploadHandler={files => fileUploadHandler(files, "REVISED_PO_DOC")} disabled={!isUploadRevisedPoPermitted}  />
                                                </div>
                                            )
                                        }
                                    </>
                                }   
                            </div>
                        </div>
                        <div className="flex justify-content-center">
                            <Button applyThrottle={true} className="" disabled={(buyerPO?.isNormalPunchDone && !buyerPO?.isPartiallyUpdated && buyerPO.isRevisedDetailsEntered) || buyerPO?.statusId === 6} permissions={[12]} label="UPDATE PO DETAILS" outlined onClick={() => handlePunchClick(buyerPO, buyerPOItems)}/>
                        </div>
                    </TabPanel>
                    {
                        buyerPO?.isPunchDone && (
                            <TabPanel header="Scheduling">
                                <Scheduling 
                                    setIsLoading={setIsLoading} 
                                    getBuyerPO={getBuyerPO} 
                                    materialData={materialData} 
                                    setBuyerPOItems={setBuyerPOItems} 
                                    buyerPOItems={buyerPOItems} 
                                    buyerPO={buyerPO} 
                                    poSchedule={poSchedule} 
                                    poScheduleItems={poScheduleItems} 
                                    showSubmitPO={showSubmitPO}
                                    scheduleCreatedUsers={poScheduleCreatedUsers}
                                    poPunch={poPunch}
                                    setBuyerPO={setBuyerPO}
                                    handleUpdatedPOPunch={handleUpdatedPOPunch}
                                    poPunchItems={poPunchItems}
                                    dispatchNoteItems={dispatchNoteItems}
                                />
                            </TabPanel>
                        )
                    }
                    {
                        (buyerPO?.isPunchDone && poPunch?.length) && (
                            <TabPanel header="History">
                                <SubmitPOQuantity 
                                    isPunchDisable={isPunchDisable} 
                                    setIsLoading={setIsLoading} 
                                    materialData={materialData} 
                                    getBuyerPO={getBuyerPO} 
                                    setBuyerPO={setBuyerPO} 
                                    setBuyerPOItems={setBuyerPOItems} 
                                    setPOPunch={setPOPunch} 
                                    setPOPunchItems={setPOPunchItems} 
                                    buyerPO={buyerPO} 
                                    buyerPOItems={buyerPOItems} 
                                    poPunch={poPunch} 
                                    poPunchItems={poPunchItems}
                                    poPunchCreatedUsers={poPunchCreatedUsers}
                                    handleUpdatedPOPunch={handleUpdatedPOPunch}
                                />
                            </TabPanel>
                        )
                    }
                </TabView>
            }
        </div>
    )
}

export default POPunch;